import { CustomError, sleep } from '../../helpers';

//
// Mock response
//
export const mockResponse = async (data, time = 1000) => {
    await sleep(time);

    // Ejemplo de respuesta de error
    return data;
    // Ejemplo de respuesta exitosa
    // return {
    //     code: 200,
    //     message: 'Ok',
    //     notification: {
    //         id: 1,
    //         id_notification_status: 4,
    //         sms_status: 'failure',
    //     }
    // };
};

export const mockResponseError = async (time = 1000) => {
    await sleep(time);

    // Ejemplo de respuesta de error
    throw new CustomError({
        // error: 'is not a mobile number',
        // error: 'jamon y queso: +5491139368836',
        error: 'Provider returned invalid state',
        // error: 'Provider could not send notification to: +5491139368836',
        code: 503,
        extra: {
            trace: 'tAL0If'
        }
    });
    // Ejemplo de respuesta exitosa
    // return {
    //     code: 200,
    //     message: 'Ok',
    //     notification: {
    //         id: 1,
    //         id_notification_status: 4,
    //         sms_status: 'failure',
    //     }
    // };
};

//
// Original error
//
export const errorCtech = {
    // error: 'Bad request. Please use a valid "password"',
    // code: 400,
    // extra: {
    //     // key: 'password_invalid',
    //     // invalidations: [
    //     //     'personal_data'
    //     // ],
    //     // Not found Loan credentials for user 16040
    //     trace: 'BKS80Q;ts;bI',
    //     from: 'auth',
    //     path: '/register',
    //     method: 'post'
    // }

    // error: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 779891',
    // error: 'The PDF has wrong number of pages expected.',
    error: 'Not found Loan credentials for user 10549',
    code: 404,
    extra: {
        trace: '{"store":"Seba\'s Store","idStore":1,"username":"SebaTest6","idUser":10549,"client":""}, egrSPm;z2;Le',
        from: 'loans',
        path: '/activities/2',
        method: 'get'
    }

};

export const errorCuotitas = {
    error: 'El usuario se encuentra bloqueado',
    code: 400,
    extra: {
        result: {
            Resultado: 2,
            // Mensaje: 'No se encontro el usuario en la base de datos. Compruebe el uso de mayusculas y minusculas.',
            // Mensaje: 'No se encontro el usuario en la base de datos.',
            // Mensaje: 'San Petersburgo',
            // Mensaje: 'System.NullReferenceException: Object reference not set to an instance of an object',
            // Mensaje: 'El usuario se encuentra bloqueado',
            Mensaje: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 779891',
            CodigoError: 0
        },
        from: 'loans',
        path: '/loans/2/users/person',
        method: 'put',
        trace: 'iAQ0HP;d0'
    }
};

//
// Inside CATCH { response: { data: {}}}
//
export const errorCtechInsideCatch = {
    response: {
        data: {
            // error: 'NotFoundBill',
            // error: 'Not found Loan credentials for user 10549',
            // error: 'Not found person with document 35379162',
            error: 'Bad request. Please use a valid "password"',
            code: 400,
            extra: {
                key: 'password_invalid',
                invalidations: [
                    'personal_data'
                ],
                trace: 'BKS80Q;ts;bI',
                from: 'auth',
                path: '/register',
                method: 'post'
            }
        }
    }
};

export const errorCuotitasInsideCatch = {
    response: {
        data: {
            error: 'El usuario se encuentra bloqueado',
            code: 400,
            extra: {
                result: {
                    Resultado: 2,
                    // Mensaje: 'No se encontro el usuario en la base de datos. Compruebe el uso de mayusculas y minusculas.',
                    // Mensaje: 'No se encontro el usuario en la base de datos.',
                    // Mensaje: 'Madrid',
                    Mensaje: 'System.NullReferenceException: Object reference not set to an instance of an object',
                    // Mensaje: 'El usuario se encuentra bloqueado',
                    // Mensaje: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 779891',
                    CodigoError: 0
                },
                from: 'loans',
                path: '/loans/2/users/person',
                method: 'put',
                trace: 'iAQ0HP;d0'
            }
        }
    }
};

//
// ASYNC
//
export const errorAsyncCtechApi = {
    message: 'Task with id: 4294eb42-312a-4a6d-9c79-cd2312db178f',
    task: {
        id: '4294eb42-312a-4a6d-9c79-cd2312db178f',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            name: 'NotFoundBill',
            // name: 'Bad request. Please use a valid "password"',
            code: 400,
            extra: {
                key: 'password_invalid',
                invalidations: [
                    'personal_data'
                ],
                trace: 'BKS80Q;ts;bI',
                from: 'auth',
                path: '/register',
                method: 'post'
            }
        }
    }
};

export const errorAsyncCuotitasApi = {
    message: 'Task with id: 4294eb42-312a-4a6d-9c79-cd2312db178f',
    task: {
        id: '4294eb42-312a-4a6d-9c79-cd2312db178f',
        status: {
            id: 3,
            description: 'FINISHED'
        },
        result: {
            name: 'NotSigned',
            code: 400,
            extra: {
                result: {
                    Resultado: 2,
                    // Mensaje: '',
                    // Mensaje: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia: 779891',
                    // Mensaje: 'No se pudo ejecutar el servicio web, no se recibio el request',
                    // Mensaje: 'No se encontro el usuario en la base de datos. Compruebe el uso de mayusculas y minusculas.',
                    // Mensaje: 'No se encontro el usuario en la base de datos.',
                    Mensaje: 'San Petersburgo',
                    // Mensaje: 'System.NullReferenceException: Object reference not set to an instance of an object',
                    // Mensaje: 'El usuario se encuentra bloqueado',
                    CodigoError: 0
                },
                code: 10010601
            }
        }
    }
};
//
// Get Bank Error
//
export const errorGetPersonBank = {
    response: {
        data: {
            error: 'Request failed with status code 400',
            code: 400,
            extra: {
                mensaje: 'La consulta no trajo registros',
                idError: 605,
                trace: '{"store":"pepito","idStore":743,"username":"Edu","idUser":12255,"client":"{\\"UniqueTraceId\\":\\"vS0NHK\\",\\"document\\":\\"1231232\\"}"}, yvZygO;hg'
            }
        }
    }
};
